import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

// export const useCounterStore = defineStore('counter', () => {
//   const count = ref(0)
//   const doubleCount = computed(() => count.value * 2)
//   function increment() {
//     count.value++
//   }

//   return { count, doubleCount, increment }
// })

export const userInfoStore = defineStore('userInfo', {
  state: () => ({
    userInfo: '',
  }),
  actions: {
    async setUserInfo (data) {
      this.userInfo = data
    }
  }
})

export const rewardListStore = defineStore('rewardList', {
  state: () => ({
    rewardList: '',
  }),
  actions: {
    async setRewardList (data) {
      this.rewardList = data
    }
  }
})
